import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import Modal from 'components/Modal';
import { Button } from 'components/Misc/Form';

const Unsaved = ({ enabled }) => {
	// Use history api
	const history = useHistory();

	// Store unblock ref
	const unblock = useRef();

	// Store latest location try
	const [path, setPath] = useState('');

	// Store modal's visibility
	const [visible, setVisible] = useState(false);

	// Proceed to action path
	const proceed = () => {
		// Hide modal
		setVisible(false);

		// Remove unblock ref
		unblock.current();

		// Go to action path
		history.push(path);
	};

	// Cancel path change
	const cancel = () => setVisible(false);

	useEffect(() => {
		// Block transition event if enabled
		unblock.current = history.block((location) => {
			if (enabled) {
				// Enable modal
				setVisible(true);

				// Save latest location
				setPath(location.pathname);

				// Prevent url change
				return false;
			}

			return true;
		});

		// Clean up refs
		return () => {
			if (unblock) unblock.current();
		};
	}, [enabled]);

	return (
		<Modal title="Uzmanību!" visible={visible} handleModal={cancel}>
			<div className="space-y-4">
				<p className="text-neutral-800 dark:text-white">Dotajā lapā ir nesaglabātas izmaiņas! Vai tiešām vēlaties pamest lapu?</p>

				<div className="flex justify-end space-x-2">
					<Button
						icon="check"
						theme="danger"
						value="Pamest"
						onClick={proceed}
					/>

					<Button
						icon="close"
						theme="success"
						value="Palikt"
						onClick={cancel}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default Unsaved;